import { createTheme } from '@mui/material/styles';

export const primaryColor = '#2183A6';
export const secondaryColor = '#D81159';

const theme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
    warning: {
      main: '#FFC007',
    },
    success: {
      main: '#4CB050',
    },
    text: {
      primary: '#666666',
    },
    custom: {
      background: '#F9FAFB',
      tab: '#e7e7e7',
      footer: '#f8f9fa',
      link: primaryColor,
      facebook: '#1a77f2',
      google: '#D7322D',
      info: {
        background: '#d1ecf1',
        text: '#0c5460',
      },
      warning: {
        background: '#fff3cd',
        text: '#856404',
      },
      admin: '#FEC007',
      adminDark: '#DFB22A',
      settings: {
        background: '#bebebe2a',
        warning: '#ff7b00',
      },
      sr: {
        currentUserComment: '#a7f3fd',
        staffOnlyComment: '#343a40',
      },
      cameraTitle: '#343a40b3',
      primary2: '#009BD3',
      currentUserMessage: '#ECF4FC',
      ccNote: '#D3F2D5',
      notificationTime: '#999999',
      notificationMessage: '#444444',
      communityPrice: '#69B812',
      lightGrey: '#eeeeef',
      grey: '#f4f4f4',
      lightGreen: '#dafff6',
      green: '#00daa8',
      purple: '#A246AD',
      mention: '#3396cc',
      pendingStatus: '#EA9B1A',
    },
  },
  typography: {
    // Tell Material-UI what's the font-size on the html element is.
    htmlFontSize: 10,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontSize: '62.5%',
          height: '100%',
        },
        body: {
          fontSize: '1.6rem',
          backgroundColor: '#fff',
          height: '100%',
        },
        '#react-root': {
          height: '100%',
        },
        hr: {
          margin: '1.5rem 0',
          padding: 0,
          border: 0,
          borderTop: '.1rem solid #0000001a',
        },
        a: {
          color: primaryColor,
          textDecoration: 'none',
        },
        img: {
          fontSize: '0.8rem',
        },
        '#print_area': {
          display: 'none',
        },
        '@media print': {
          '#screen_area': {
            display: 'none',
          },
          '#print_area': {
            display: 'block',
          },
        },
        '#print_area #report_body': {
          zoom: 0.5,
        },
        '#print_area #report_main': {
          maxWidth: '95rem',
        },
        '.content-area': {
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          padding: '2rem',
        },
        '.crop-long-text': {
          textOverflow: 'ellipsis',
          display: 'block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        },
        '.hide-scrollbar': {
          // add styles for mozila
          '&::-webkit-scrollbar': {
            width: '0 !important',
            display: 'none',
          },
        },
        '.center-content': {
          position: 'absolute',
          transform: 'translate(-50%, -50%)',
          top: '50%',
          left: '50%',
        },
        'input[type="time"]::-webkit-calendar-picker-indicator': {
          display: 'none',
        },
        '@media (max-width: 600px)': {
          '.content-area': {
            padding: '1rem',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '1rem',
          fontWeight: '500',
          display: 'block',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textTransform: 'none',
          fontSize: '1.6rem',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '1rem',
          backgroundColor: '#fff',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        regular: {
          height: '8rem',
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&$disabled': {
            color: '#ccc',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        endAdornment: {
          top: 'auto',
        },
      },
    },
  },
});

export default theme;
